// Constantes de PHU. Los PHU, plantillas y equipos vienen de pls/phu/configuration;
// estos valores solo cubren lo que la API no devuelve o falta por configurar.

export const SLOT_STATES = {
    DISABLED: 'disabled',
    EMPTY: 'empty',
    COOKING: 'cooking',
    READY: 'ready',
    ABOUT_TO_EXPIRE: 'about_to_expire',
    EXPIRED: 'expired'
}

export const EQUIPMENT_STATUS = {
    UNAVAILABLE: -1,
    AVAILABLE: 1,
    COOKING: 2
}

export const BLOCKED_REASONS = {
    NO_PHU_CAPACITY: 'no_phu_capacity',
    NO_COOKING_CAPACITY: 'no_cooking_capacity'
}

export const WORKSTATION_IDS = {
    BROILER: 1,
    FRYER: 2
}

export const WORKSTATIONS = [
    { id: WORKSTATION_IDS.BROILER, type: 'broiler', name: 'Broiler' },
    { id: WORKSTATION_IDS.FRYER, type: 'fryer', name: 'Fryer' }
]

// Mismo catálogo por defecto que la API cuando la cuenta no tiene phu_layout_templates.
// El tamaño lo marcan rows y columns. El nombre solo se usa si esas cifras no vienen.
export const LAYOUT_TEMPLATES = [
    { id: 1, name: '2x2', rows: 2, columns: 2 },
    { id: 2, name: '2x3', rows: 2, columns: 3 },
    { id: 3, name: '2x4', rows: 2, columns: 4 },
    { id: 4, name: '3x4', rows: 3, columns: 4 }
]

export const layoutSize = (layout) => {
    const rows = Number(layout && layout.rows) || 0
    const columns = Number(layout && layout.columns) || 0
    if (rows > 0 && columns > 0) {
        return { rows, columns }
    }
    const match = String(layout && layout.name ? layout.name : '').match(/^(\d+)\s*x\s*(\d+)$/i)
    if (match) {
        return { rows: Number(match[1]), columns: Number(match[2]) }
    }
    return { rows, columns }
}

export const normalizeLayouts = (layouts) => {
    const list = Array.isArray(layouts) ? layouts : Object.values(layouts || {})
    const normalized = list
        .map((layout) => {
            const size = layoutSize(layout)
            return { id: layout.id, name: layout.name, rows: size.rows, columns: size.columns }
        })
        .filter((layout) => layout.rows > 0 && layout.columns > 0)
    return normalized.length ? normalized : LAYOUT_TEMPLATES.map((layout) => ({ ...layout }))
}

export const MIN_SLOTS_PER_PRODUCT = 2
export const DEFAULT_HOLDING_TIME = 20
export const EXAMPLE_HOLDING_MAX_UNITS = 10
export const ABOUT_TO_EXPIRE_RATIO = 0.25
